import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { useCongress } from '../../../congress/hooks'

export default function Card ({ uuid, name, multiple }) {
  const { generateLink } = useCongress()

  return (
    <Container>
      <StyledLink to={generateLink(`/contact/${uuid}&${multiple}`)}>
        <CardTitle>{name}</CardTitle>
      </StyledLink>
    </Container>
  )
}

const Container = styled.div`
  margin-bottom: 18px;
  background: #FFF;
  box-shadow: 0 3px 20px rgba(197, 217, 232, 0.5);
  border-radius: 12px;
`

const CardTitle = styled.p`
  font-size: 18px;
  line-height: 21px;
  text-align: center;
  color: #19A0FA;
`
const StyledLink = styled(Link)`
  display: flex;
  padding: 3.2rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  text-decoration: none !important;
`
